import React from "react";

import { useAuth } from "hooks/useAuth";

const UserGreeting = () => {
  
  const { loggedInUser, viewEntity, isAdmin } = useAuth();

  return (
    <div className="flex flex-col items-end">
      <div className="text-sm">
        
        <span className="font-medium">{loggedInUser?.name}</span>
      </div>

      {isAdmin && (
        <div className="text-[10px] text-blue-600 dark:text-blue-200">
          {viewEntity?.authorization?.role}
        </div>
      )}
    </div>
  );
};

export default UserGreeting;
